import React, {useMemo} from "react";
import { connect } from "react-redux";

import {getNextWizardSteps} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions2";
import MaterialsWizardContext from "./MaterialsWizardContext";
import {getFeatureGroupFromWizardGroup} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import Config from "../../../config";


const MaterialsWizardContextProvider = (props) => {

  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues} = props;

  const wizardSteps = useMemo(() => {
    if (!wizardActiveItem) {
      return []
    }
    return getNextWizardSteps(wizardActiveItem, wizardActiveStep, wizardSelectedValues)
  }, [wizardActiveItem, wizardActiveStep, wizardSelectedValues]);

  const stepGroups = wizardSteps.find(step => step.stepIndex === wizardActiveStep);
  const currentGroups = stepGroups?.stepGroups || [];
  const wizardGroup = currentGroups[0];
  const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);


  const wizContextValues = {
    wizardSteps,
    currentGroups,
    wizardGroup,
    featureGroup,
  }

  if (Config.isDevMode()) {
    console.log("wizContextValues", wizContextValues);
  }

  return (
    <MaterialsWizardContext.Provider value={wizContextValues}>
      {props.children}
    </MaterialsWizardContext.Provider>
  )
};

const mapStateToProps = (store, ownProps) => {
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues} = store.wizardState;
  const {wizardValues} = ownProps;

  return {
    wizardActiveItem: ownProps.wizardItem ?? wizardActiveItem,
    wizardActiveStep: ownProps.wizardStep ?? wizardActiveStep,
    wizardSelectedValues: wizardValues ?? wizardSelectedValues,
  };
};

export default connect(mapStateToProps)(MaterialsWizardContextProvider)
